module.exports = __webpack_public_path__ + "img/PACE_Logo.c59a40be.jpg";